<template>
  <div class="SuccessfulCaseDetails" v-loading="loading">
    <!-- 成功案例详情 -->
    <div class="cpzx_bj">
      <img src="@/assets/img/spzx_xqy/banner-bg.png" alt="" />
      <ul class="cpzx_bj_text">
        <li>成功案例</li>
        <li>不断提升自身技术及用户体验</li>
        <li></li>
      </ul>
    </div>
    <div class="breadcrumb">
      <div class="breadcrumbBox">
        <img src="@/assets/img/spzx/cpzx_home.png" alt="" />
        <div class="breadcrumbBox_text">
          <span @click="goToHome" class="clickable">首页&nbsp;></span>
          <span @click="goToSuccessfulCase" class="clickable">成功案例&nbsp;></span>
          <span>案例详情</span>
        </div>
      </div>
    </div>
    <div class="Solution_box" id="main-content">
      <div class="contentBox">
        <div class="caseContentBox" v-html="innerText"></div>
      </div>
    </div>
  </div>
</template>

<script>
import ArticleCenter from "@/api/articleCenter.js";

export default {
  name: "SuccessfulCaseDetails",
  data() {
    return {
      innerText: "",
      loading: false
    };
  },
  methods: {
    // 返回首页
    goToHome() {
      this.$LocalCache.setCath("navigationBarIndex", 0);
      this.$router.push({ name: 'Home' });
    },
    // 返回成功案例
    goToSuccessfulCase() {
      this.$LocalCache.setCath("navigationBarIndex", 4);
      this.$router.push({ name: 'SuccessfulCase' });
    },
    // 获取成功案例详情
    async getCaseDetail(articleCenterId) {
      this.loading = true;
      try {
        const { code, msg, data } = await ArticleCenter.getDetail({ articleCenterId });
        if (code === 200) {
          this.innerText = data.innerText || '';
          // 等待DOM更新后处理图片
          this.$nextTick(() => {
            this.handleImages();
          });
        } else {
          this.$message.error(msg || '获取案例详情失败');
        }
      } catch (error) {
        console.error('获取案例详情失败:', error);
        this.$message.error('获取案例详情失败');
      } finally {
        this.loading = false;
      }
    },
    // 处理图片尺寸
    handleImages() {
      // 不需要任何JavaScript处理，直接通过CSS统一控制
    }
  },
  mounted(){
    // 获取成功案例详情
    const articleCenterId = this.$route.query.articleCenterId;
    if (articleCenterId) {
      this.getCaseDetail(articleCenterId);
    } else {
      this.$message.error('缺少案例ID参数');
      // 返回成功案例页面
      this.goToSuccessfulCase();
    }

    // 页面加载后自动滚动到核心内容区域
    this.$nextTick(() => {
      const mainContent = document.getElementById('main-content');
      if (mainContent) {
        // 计算面包屑导航的高度，确保面包屑显示在视口中
        const breadcrumb = document.querySelector('.breadcrumb');
        const breadcrumbHeight = breadcrumb ? breadcrumb.offsetHeight : 48;
        const bannerHeight = 274; // banner的固定高度

        // 滚动到面包屑导航下方一点点位置，让用户能看到面包屑
        window.scrollTo({
          top: bannerHeight + breadcrumbHeight - 10,
          behavior: 'smooth'
        });
      }
    });
  }
};
</script>

<style scoped lang="scss">
.SuccessfulCaseDetails {
  width: 100%;
  .cpzx_bj {
    width: 100%;
    height: 274px;
    position: relative;
    img {
      width: 100%;
      height: 274px;
    }
    .cpzx_bj_text {
      width: 310px;
      height: 134px;
      position: absolute;
      top: 100px;
      left: 50%;
      margin-left: -155px;
      li {
        color: #fff;
        &:nth-child(1) {
          width: 100%;
          height: 56px;
          font-size: 30px;
          padding-left: 68px;
        }

        &:nth-child(2) {
          width: 100%;
          height: 24px;
          font-size: 18px;
        }
        &:nth-child(3) {
          width: 220px;
          height: 4px;
          background-color: #fff;
          margin-top: 22px;
          margin-left: 16px;
          position: relative;
          &:after {
            content: "";
            width: 60px;
            height: 10px;
            background-color: #fff;
            position: absolute;
            top: -3px;
            left: 80px;
          }
        }
      }
    }
  }
  .breadcrumb {
    width: 100%;
    height: 48px;
    display: flex;
    justify-content: center;

    .breadcrumbBox {
      width: 1206px;
      height: 48px;
      font-family: Source Han Sans CN;
      display: flex;
      align-items: center;
      position: relative;

      img {
        width: 22px;
        height: 20px;
      }

      .breadcrumbBox_text {
        position: absolute;
        top: 17px;
        left: 40px;
      }

      span {
        font-size: 16px;

        &:nth-child(1) {
          color: #666666;
        }

        &:nth-child(2) {
          color: #2b8737;
        }

        &:nth-child(3) {
          color: #2b8737;
        }

        &.clickable {
          cursor: pointer;

          &:hover {
            opacity: 0.7;
            text-decoration: underline;
          }
        }
      }
    }
  }
  .Solution_box {
    width: 100%;
    background-color: #f5f5f5;
    padding: 30px 0 36px 0;
    display: flex;
    justify-content: center;
    .contentBox {
      width: 1206px;
      max-width: 100%;
      padding: 0 20px;
      margin: 0 auto;
      .caseContentBox {
        width: 100%;
        background-color: #fff;
        min-height: 800px;
        font-size: 16px;
        line-height: 26px;
        padding: 40px;

        // 设置内容区域的统一宽度
        $content-width: 1000px;
        $content-width-medium: 800px;
        $content-width-small: 100%;

        // 所有内容元素的基础样式
        :deep(*) {
          box-sizing: border-box;
        }

        // 图片容器样式 - 与文字完全一致的宽度
        :deep(p:has(img)) {
          width: 100%;
          max-width: $content-width;
          margin: 20px auto;
          padding: 0;
          text-align: center;

          img {
            width: 100%;
          }
        }

        // 文字段落样式 - 与图片完全一致的宽度
        :deep(p:not(:has(img))) {
          width: 100%;
          max-width: $content-width;
          margin: 16px auto;
          padding: 0 20px;
          text-align: justify;
          line-height: 1.8;
          box-sizing: border-box;
        }

        // 标题样式 - 与图片文字完全一致的宽度
        :deep(h1, h2, h3, h4, h5, h6) {
          width: 100%;
          max-width: $content-width;
          margin: 20px auto;
          padding: 0 20px;
          box-sizing: border-box;
        }

        // 表格样式 - 与图片文字完全一致的宽度
        :deep(table) {
          width: 100%;
          max-width: $content-width;
          margin: 20px auto;
          box-sizing: border-box;
        }

        // 列表样式 - 与图片文字完全一致的宽度
        :deep(ul, ol) {
          width: 100%;
          max-width: $content-width;
          margin: 16px auto;
          padding: 0 20px;
          box-sizing: border-box;
        }

        // 响应式调整 - 中等屏幕
        @media screen and (max-width: 1200px) {
          padding: 30px;

          :deep(p:has(img)) {

            img {
              width: 100%;
            }
          }

          :deep(p:not(:has(img))) {
            width: 100%;
          }

          :deep(h1, h2, h3, h4, h5, h6) {
            max-width: $content-width-medium;
            padding: 0 15px;
          }

          :deep(table) {
            max-width: $content-width-medium;
          }

          :deep(ul, ol) {
            max-width: $content-width-medium;
            padding: 0 15px;
          }
        }

        // 响应式调整 - 小屏幕
        @media screen and (max-width: 768px) {
          padding: 20px;
          font-size: 14px;
          line-height: 24px;

          :deep(p:has(img)) {
            width: 100%;

            img {
              width: 100%;
            }
          }

          :deep(p:not(:has(img))) {
            width: 100%;
          }

          :deep(h1, h2, h3, h4, h5, h6) {
            max-width: $content-width-small;
            margin: 15px auto;
            padding: 0 10px;
          }

          :deep(table) {
            max-width: $content-width-small;
          }

          :deep(ul, ol) {
            max-width: $content-width-small;
            padding: 0 10px;
          }
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/views/successfulCaseDetails/SuccessfulCaseDetails.vue